// extracted by mini-css-extract-plugin
export default {"mainClass":"BlankPage_mainClass__5E+K-"};